<template>
  <div class="login-contentPage">
    <div class="loginPage_left">
      <img :src="loginLeft">
    </div>
    <div class="loginPage_right">
      <div>
      <div class="loginContent">
        <div class="loginContent1">
          <div>
          <img :src="loginLogo">
          </div>
        </div>
        <div class="loginContent2">
          {{loginTitle}}
        </div>
        <div class="loginContent3">
          <el-form :model="form"
                   ref="form"
                   label-position="left"
                   label-width="0px">
            <el-form-item prop="username" class="login-input-content"
                          :class="focus ? 'color' : ''">
              <div class="login-account">
               <el-input @focus="onfocus" @blur="changeCount"
                         type="text"
                         v-model="form.username"
                         auto-complete="off"
                          placeholder="请输入您的账号" class="loginNewGT">
                  <template slot="prepend">
                    <div>
                      <img src="../assets/images/login/zhanghao.png">
                    </div>
                  </template>
                </el-input>
              </div>
            </el-form-item>
            <el-form-item prop="password"
                          class="login-input-content" :class="Focus ? 'color' : '' ">
              <div class="login-account">
                <el-input @focus="onFocus"
                          @keyup.enter.native="handleSubmit2"
                          type="password"
                          @blur="changeCounts"
                          v-model="form.password"
                          auto-complete="off"
                          placeholder="请输入您的密码" class="loginNewGT">
                  <template slot="prepend">
                    <div class="">
                      <img src="../assets/images/login/mima.png">
                    </div>
                  </template>
                </el-input>
              </div>
            </el-form-item>
            <el-form-item class="login-input-content">
              <div class="remember-state">
                <el-checkbox v-model="checked" class="remember-stateNew">记住密码</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item class="login-input-content">
              <el-button type="primary"
                         class="login-btn"
                         style="background-color: #910000"
                         v-loading="loading"
                         @click.native.prevent="handleSubmit2()">
                登 录
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import {IMAGE_LOGIN_LEFT, IMAGE_LOGIN_LOGO,LOGIN_TITLE} from '@/api/local.js'
import { login, memberLogin, fetchMenuList } from '@/api/customer.js'
import { getCusTypes } from '@/api/set.js'
export default {
  name: 'login',
  data () {
    return {
      loginTitle: LOGIN_TITLE,
      year: '',
      choose: true,
      focus: false,
      Focus: false,
      title: '',
      titleName: '欢迎登录',
      loading: false,
      form: {
        username: '',
        password: ''
      },
      checked: false,
      remember: '',
      menuList: [],
      firstPage: '' // 第一次进入系统时要展示的页面
    }
  },
  computed: {
    loginLeft(){
      return IMAGE_LOGIN_LEFT
    },
    loginLogo(){
      return IMAGE_LOGIN_LOGO
    }
  },
  mounted () { },
  created () {
    this.year = new Date().getFullYear()
    if (Lockr.get('authKey')) {
      // const firstRoutePath = Lockr.get('firstRoutePath')
      // this.$router.push(firstRoutePath)
    }
  },
  methods: {
    // 动态获取菜单
    async getMemuList () {
      const result = await fetchMenuList()
      const { code, message, result: res } = result.data
      if (code === '200') {
        Lockr.set('cloudShopMid', result.data.result.modelSet.cloudShopMid)
        const { treeList = [], subSystems = [] } = res || {}
        Lockr.set('subSystems', subSystems)
        // 受众单独处理
        for (let item of treeList) {
          if (item.attributes.perms === 'audiences') {
            this.load(treeList)
            return
          }
        }
        this.menuList = treeList.map(item => {
          console.log(item, 'item')
          // 给每棵树第一层加上path
          const route = item.children.length > 0 ? item.children[0].children[0].attributes.route : item.attributes.route

          return {
            name: item.text,
            id: item.id,
            path: route,
            perms: item.attributes.perms,
            children: item.children,
            pr: item.attributes.pr
          }
        })
        Lockr.set('menuList', this.menuList)
        const path = this.menuList[0].path
        router.push(path)
      } else {
        // _g.toastMsg('error', message)
      }
    },
    // 获取受众类型列表
    load (treeList) {
      getCusTypes().then((res) => {
        if (res.data.code == 200) {
          const obj = treeList.find(item => item.attributes.perms === 'audiences')
          // const data = res.data.result.reverse()
          const data = res.data.result
          // 导出功能单独处理 除了导出之外的树
          const children = JSON.parse(JSON.stringify(obj.children))
          obj.children = children.filter(({ attributes }) => attributes.perms !== 'audiences:export')
          // 单独的导出那棵树
          const exportList = children.filter(item => item.attributes.perms === 'audiences:export')
          data.forEach(item => {
            // 去掉订单模型的
            if (item.typeId !== 50) {
              item.text = item.name
              item.attributes = {
                icon: 'iconfont ' + item.icon
              }
              item.children = JSON.parse(JSON.stringify(obj.children))
            }
          })
          // 将导出和getCusTypes接口获取回来的data放在一起
          obj.children = [...data, ...exportList]
          // 改变路径
          data.forEach(({ children, id }) => {
            children.forEach(item => (item.attributes.route = `${item.attributes.route}/${id}`))
          })
          this.menuList = treeList.map(item => {
            // 给每棵树第一层加上path
            const route = item.children.length > 0 ? item.children[0].children[0].attributes.route : item.attributes.route

            return {
              name: item.text,
              id: item.id,
              path: route,
              perms: item.attributes.perms,
              children: item.children,
              pr: item.attributes.pr
            }
          })
          Lockr.set('menuList', this.menuList)
          const path = this.menuList[0].path
          router.push(path)
        }
      })
    },
    onfocus () {
      this.focus = true
    },
    onFocus () {
      this.Focus = true
    },
    changeCount () {
      this.focus = false
    },
    changeCounts () {
      this.Focus = false
    },
    handleSubmit2 () {
      if (this.choose === true) {
        this.loading = true
        if (this.checked === true) {
          this.remember = 1
        } else {
          this.remember = 0
        }
        login(this.form.username, this.form.password, this.remember).then((res) => {
          if (res.data.code === 0) {
            // 清空登录数据
            this.form = {
              username: '',
              password: ''
            }
            // 处理状态
            let authKey = res.data.data.authKey
            let sessionId = res.data.data.sessionId
            let userInfo = res.data.data.userInfo
            this.loading = false
            axios.defaults.headers.authKey = authKey
            axios.defaults.headers.sessionId = sessionId
            Lockr.set('authKey', authKey)
            Lockr.set('sessionId', sessionId)
            Lockr.set('userInfo', userInfo)
            _g.toastMsg('success', res.data.error)

            this.getMemuList()

            // let query = this.$route.query.redirect
            // if (query) {
            //   router.push(query)
            // } else {
            //   router.push('/home/data-center')
            // }
          } else {
            this.loading = false
            _g.toastMsg('error', res.data.error)
          }
        })
      } else {
        this.loading = true
        if (this.checked === true) {
          this.remember = 1
        } else {
          this.remember = 0
        }
        memberLogin(this.form.username, this.form.password, this.remember).then((res) => {
          if (res.data.code === 0) {
            // 清空登录数据
            this.form = {
              username: '',
              password: ''
            }
            let authKey = res.data.data.authKey
            let sessionId = res.data.data.sessionId
            let userInfo = res.data.data.userInfo
            console.log('login', res.data.data)
            this.loading = false
            axios.defaults.headers.authKey = authKey
            axios.defaults.headers.sessionId = sessionId
            Lockr.set('authKey', authKey)
            Lockr.set('sessionId', sessionId)
            Lockr.set('userInfo', userInfo)
            _g.toastMsg('success', res.data.error)
            this.getMemuList()
          } else {
            this.loading = false
          }
        })
      }
    }
  }
}
</script>
<style scoped>
  .login-contentPage {
    width: 100%;
    height: 100%;
    background-color: #f1f1f1;
    /*background: url('../assets/images/login/loginLeft.gif') no-repeat center center #F1F1F1;*/
    /*background-size: 100% 100%;*/
    overflow-y: none !important;
    position: relative;
  }
  .loginPage_left {
    /*border: 1px solid #000;*/
    width: 55%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .loginPage_left img {
    width: 100%;
    height: auto;
  }
  .loginPage_right {
    background: url('../assets/images/login/baidi.png') no-repeat center center #f1f1f1;
    background-size: 100% 100%;
    position: absolute;
    right: 0;
    top: 0;
    width: 45%;
    height: 100%;
  }
  .loginPage_right > div {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .loginContent {
    /*border: 1px solid;*/
  }
  .loginContent1 {
    display: flex;
    justify-content: center;
  }
  .loginContent1 > div {
    /*border: 1px solid;*/
    border-radius: 20px;
    -moz-box-shadow: 1px 3px 2px #e3e3e3; /* 老的 Firefox */
    box-shadow: 1px 3px 2px #e3e3e3;
    margin-bottom: 30px;
  }
  .loginContent2 {
    color: #000;
    font-size: 26px;
    font-weight: 600;
  }
</style>
